import React from 'react';

const { Consumer, Provider } = React.createContext({});

export const SearchResultsConsumer = Consumer;

export class SearchResultsProvider extends React.Component {
  state = {};
  setSearchResults = (key, query, results) => {
    this.setState(prevState => ({
      ...prevState,
      [key]: {
        query,
        results,
      },
    }));
  };

  getSearchResults = key => {
    const search = this.state[key];
    if (search) {
      return search;
    }
    return {};
  };

  render() {
    const context = {
      getSearchResults: this.getSearchResults,
      setSearchResults: this.setSearchResults,
    };
    return <Provider value={context}>{this.props.children}</Provider>;
  }
}

export const withSearch = key => Component => props => (
  <Consumer>
    {({ getSearchResults, setSearchResults }) => (
      <Component
        {...props}
        getSearchResults={getSearchResults.bind(undefined, key)}
        setSearchResults={setSearchResults.bind(undefined, key)}
      />
    )}
  </Consumer>
);



// WEBPACK FOOTER //
// ./src/context/SearchResultsContext.jsx